import { CreateVehicleRequest } from '../models/request-data-types';

export function mapToVehicle(vehicleForm: any): CreateVehicleRequest {
    const createVehicleRequest: CreateVehicleRequest = {
        vehicleUse: vehicleForm.vehicleUse,
        registrationNumber: vehicleForm.registrationNumber,
        modelId: vehicleForm.model.id,
        yearOfManufacture: new Date(vehicleForm.yearOfManufacture)
            .getFullYear()
            .toString(),
        carryingCapacity: parseInt(vehicleForm.carryingCapacity),
        vehicleType: vehicleForm.vehicleType,
        weightCategory: vehicleForm.weight,
        vehicleValue: parseFloat(vehicleForm.vehicleValue),
        engineCapacity: parseFloat(vehicleForm.engineCapacity),
    };
    return createVehicleRequest;
}
